import React, { Fragment, useEffect, useState } from "react";
import { getActiveItemsByWarehouseid, getWarehouseKeyValueList } from "../../../services";
import { Toaster, toast } from "react-hot-toast";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import { addStockClosing } from "../../../services/Inventory/OtherServices";
import { Navigate, useNavigate } from "react-router-dom";

const StockClosingNew = () => {
    const [warehouseOptions, setWarehouseOptions] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const tempRow = {
        closingStockBoxQuantity: "",
        closingStockOpenQuantity: "",
        currentStockBoxQuantity: 0,
        currentStockOpenQuantity: 0,
        unitName: "",
        packUnitTitle: "",
        itemId: null,
        value: null,
        itemTitle: "",
        // beanBillBatch: [{
        //     batchQuantity: 0,
        //     batchNumber: "",
        //     Rate: "",
        //     batchManufacturingDate: "",
        //     batchExpiredDate: "",
        //     qtyConsumed: 0
        // }],
        // beanBatchList: []
    };
    const [itemOptions, setItemOptions] = useState(null);
    const [itemOptions2, setItemOptions2] = useState(null);
    const [rows, setRows] = useState([tempRow]);
    const [loading, setLoading] = useState(false);
    const [itemLoading, setItemLoading] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res?.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWarehouseOptions(options);
                setSelectedWarehouse(options[0]);
            } else {
                toast(res.message);
            }
        });
    }, []);

    useEffect(() => {
        if (selectedWarehouse) {
            getWarehouseItems();
        }
    }, [selectedWarehouse]);

    const getWarehouseItems = () => {
        let data = {
            page: 0,
            search: "",
            size: -1,
            uuid: selectedWarehouse.value,
        };
        setItemLoading(true);
        getActiveItemsByWarehouseid(data).then((res) => {
            if (res.errorCode === 0) {
                const options = res?.responsePacket.data?.map((d) => ({
                    itemId: d.itemId,
                    value: d.itemTitle,
                    itemTitle: d.itemTitle,
                    label: d.itemTitle,
                    currentStockBoxQuantity: d.currentStockBoxQuantity,
                    currentStockOpenQuantity: d.currentStockOpenQuantity,
                    closingStockBoxQuantity: "",
                    closingStockOpenQuantity: "",
                    packUnitTitle: d.packUnitTitle,
                    unitName: d.unitName,
                    label: (
                        <div className="selectItemOptions">
                            <div className="font-size-14 font-weight-bold">{d.itemTitle}</div>
                            <div className={`row font-size-13 ${d.currentStockBoxQuantity <= 0 && d.currentStockOpenQuantity <= 0 ? "text-danger" : ""}`}>
                                <div className="col-6">Available Stock:</div>
                                <div className="col-3">
                                    <span>
                                        {d.currentStockBoxQuantity?.toFixed(2)} ({d.packUnitTitle})
                                    </span>
                                </div>
                                <div className="col-3">
                                    <span>
                                        {d.currentStockOpenQuantity?.toFixed(2)} ({d.unitName})
                                    </span>
                                </div>
                            </div>
                            <span className="font-size-13">Rate: {d.sellingPriceValue}</span>
                        </div>
                    ),
                    // beanBatchList: d?.beanBillBatch
                }));
                setItemLoading(false);
                setItemOptions(options);
                setItemOptions2(options);
            } else {
                toast(res.message);
            }
        });
    };

    const handleSelectWarehouse = (e) => {
        setRows([tempRow]);
        setSelectedWarehouse(e);
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].itemId = e.itemId;
        obj[i].value = e.value;
        obj[i].itemTitle = e.itemTitle;
        obj[i].label = e.itemTitle;
        obj[i].currentStockBoxQuantity = e.currentStockBoxQuantity;
        obj[i].currentStockOpenQuantity = e.currentStockOpenQuantity;
        obj[i].closingStockBoxQuantity = e.closingStockBoxQuantity;
        obj[i].closingStockOpenQuantity = e.closingStockOpenQuantity;
        obj[i].unitName = e.unitName;
        obj[i].packUnitTitle = e.packUnitTitle;
        // obj[i].beanBatchList = e.beanBatchList
        setRows(obj);

        var setSend = false;
        var filterOptions = [];
        itemOptions2 &&
            itemOptions2?.map((a) => {
                obj &&
                    obj?.map((b) => {
                        if (a.itemId === b.itemId) {
                            setSend = true;
                        }
                    });
                if (!setSend) {
                    filterOptions.push(a);
                }
                setSend = false;
            });
        setItemOptions(filterOptions);
    };

    const handleAddRow = () => {
        setRows([...rows, tempRow]);
    };

    const handleClear = (id, i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        setRows(obj);
    };

    const handleBoxQty = (e, i) => {
        const obj = [...rows];
        if (e.target.value === "") {
            obj[i].closingStockBoxQuantity = "";
            setRows(obj);
            return;
        }
        let qt = Number(e.target.value);
        obj[i].closingStockBoxQuantity = qt;
        setRows(obj);
    };

    const handleOpenQty = (e, i) => {
        const obj = [...rows];
        if (e.target.value === "") {
            obj[i].closingStockOpenQuantity = "";
            setRows(obj);
            return;
        }
        let qt = Number(e.target.value);
        obj[i].closingStockOpenQuantity = qt;
        setRows(obj);
    };

    const handleSave = () => {
        if (!selectedWarehouse) {
            toast("Select Warehouse");
            return;
        }
        setLoading(true);
        let itemBeanList = [];
        rows?.map((item) => {
            if (item.closingStockBoxQuantity !== "" || item.closingStockOpenQuantity !== "") {
                const itemObj = {
                    itemId: item.itemId,
                    itemTitle: item.itemTitle,
                    currentStockBoxQuantity: item.currentStockBoxQuantity,
                    currentStockOpenQuantity: item.currentStockOpenQuantity,
                    closingStockBoxQuantity: item.closingStockBoxQuantity !== "" ? item.closingStockBoxQuantity : 0,
                    closingStockOpenQuantity: item.closingStockOpenQuantity !== "" ? item.closingStockOpenQuantity : 0,
                    // beanBillBatch: item?.beanBillBatch
                };
                itemBeanList.push(itemObj);
            }
        });
        if (itemBeanList?.length === 0) {
            toast("Select item");
            setLoading(false);
            return;
        }

        addStockClosing(selectedWarehouse.value, itemBeanList).then((res) => {
            if (res.errorCode === 0) {
                toast.success(res.message);
                navigate("/stockClosing/list");
                setLoading(false);
                setSelectedWarehouse(warehouseOptions[0]);
                setRows([tempRow]);
            } else {
                toast(res.message);
                return;
            }
        });
    };
    const handleSubRow = (itemIndex) => {
        const data = rows.map((e, i) => {
            if (i === itemIndex) {
                return {
                    ...e, beanBillBatch: [...e?.beanBillBatch, {
                        batchQuantity: 0,
                        batchNumber: "",
                        Rate: "",
                        batchManufacturingDate: "",
                        batchExpiredDate: "",
                        qtyConsumed: 0
                    }]
                }
            }
            else {
                return e;
            }
        })
        setRows(data)
    }
    const removeSubRows = (i, j) => {
        const data = rows.map((item, ind) => {
            if (ind !== i) {
                return item;
            }
            else {
                return { ...item, beanBillBatch: item.beanBillBatch.filter((item2, index2) => index2 !== j) }
            }
        })
        setRows(data)
    }

    const handleSubRowchanges = (i, j, e, name, quantity, batchNumber) => {
        if (name === "qtyConsumed" && batchNumber !== "No Batch Found") {
            if (e > quantity) {
                toast.error("Quantity selected is greater than available");
                return;
            }
        }
        const data = rows.map((row, ind) => {
            if (ind === i) {
                return {
                    ...row,
                    beanBillBatch: row.beanBillBatch.map((bean, index) => {
                        if (index === j && name === "batchNumber") {
                            return { ...e, qtyConsumed: "" }
                        }
                        if (index === j && name === "qtyConsumed") {
                            return { ...bean, [name]: e }
                        }
                        return bean;
                    })
                };
            }
            return row;
        });
        setRows(data);
    };


    return (
        <>
            <div className="col-12 pl-3">
                <h1 className="fill list-header d-flex  align-items-center bg-white p-3 border-bottom">
                    <ReceiptIcon />
                    New Stock Closing
                </h1>

                <br />
                <div className="d-flex align-items-center pl-3">
                    <div className="mr-4">Warehouse:</div>
                    <div style={{ minWidth: "200px" }}>
                        <Select value={selectedWarehouse} isDisabled={!warehouseOptions} options={warehouseOptions} onChange={(e) => handleSelectWarehouse(e)} />
                    </div>
                </div>
                <br />
                <table className="customTable col-12">
                    <tbody>
                        <tr>
                            <td></td>
                            <td>Item</td>
                            <td>Current Pack Qty</td>
                            <td>Closing Box Qty</td>
                            <td>Current Loose Qty</td>
                            <td>Closing Loose Qty</td>
                        </tr>
                        {rows &&
                            rows?.map((data, i) => {
                                return (
                                    <Fragment>
                                        <tr key={i}>
                                            <td>
                                                <div className={itemLoading ? "spinner-loader" : ""}></div>
                                            </td>
                                            <td className="selectMenuItemList" style={{ width: "300px" }}>
                                                <Select isDisabled={!selectedWarehouse || itemLoading} options={itemOptions} value={data} onChange={(e) => handleItem(e, i)} />
                                            </td>
                                            <td>
                                                <span>{data.currentStockBoxQuantity + " " + data.packUnitTitle}</span>
                                            </td>
                                            <td>
                                                <input disabled={!selectedWarehouse || itemLoading} autoComplete="off" min={0} type="number" value={data.closingStockBoxQuantity} onChange={(e) => handleBoxQty(e, i)} />
                                            </td>
                                            <td>
                                                <span>{data.currentStockOpenQuantity + " " + data.unitName}</span>
                                            </td>
                                            <td>
                                                <input disabled={!selectedWarehouse || itemLoading} autoComplete="off" min={0} type="number" value={data.closingStockOpenQuantity} onChange={(e) => handleOpenQty(e, i)} />
                                            </td>
                                            <td style={{ cursor: "pointer" }} onClick={() => handleClear(data.itemId, i)}>
                                                {rows.length > 1 && <i className="fa fa-times"></i>}
                                            </td>
                                        </tr>
                                        {/* <tr style={{ width: "100%" }}>
                                            <td style={{ padding: 0 }} colSpan={16}>
                                                <table style={{ width: "100%", paddingRight: "5px" }} className=" border text-center sub-table">
                                                    <thead>
                                                        <tr className="border">
                                                            <td> Batch </td>
                                                            <td> Batch Qty</td>
                                                            <td> Qty </td>
                                                            {/* <td> Rate </td> 
                                                            <td> Mfg </td>
                                                            <td> Expiry </td>
                                                            <td style={{ width: "30px" }}>
                                                                <button
                                                                    id="ember1426"
                                                                    className="btn btn-default addbtn"
                                                                    onClick={() => handleSubRow(i)}
                                                                >
                                                                    <AddIcon
                                                                        style={{ color: "blue", }}
                                                                    />{" "}
                                                                    Add
                                                                    More

                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    {data?.beanBillBatch?.map((billBatch, j) => {
                                                        let allBatchOptions = data?.beanBatchList.filter((e, index) => !data?.beanBillBatch.find((f) => f.batchNumber === e?.batchNumber))
                                                        return <tbody>
                                                            <tr>
                                                                <td  >
                                                                    <Select
                                                                        isDisabled={itemLoading}
                                                                        styles={{
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                minWidth: '180px',
                                                                                fontSize: "13px"
                                                                            }),
                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                minWidth: '180px',
                                                                                fontSize: "13px"
                                                                            }),
                                                                        }}
                                                                        name="batchNumber"
                                                                        onChange={(e) => handleSubRowchanges(i, j, e, "batchNumber")}
                                                                        value={{
                                                                            value: billBatch?.batchNumber,
                                                                            label: billBatch?.batchNumber
                                                                        }}
                                                                        options={[...(allBatchOptions && allBatchOptions?.length > 0
                                                                            ? allBatchOptions.map(e => ({
                                                                                ...e,
                                                                                value: e.batchNumber,
                                                                                label: e.batchNumber
                                                                            }))
                                                                            : []
                                                                        )
                                                                        ]}
                                                                    />


                                                                </td>
                                                                <td >{billBatch?.batchQuantity}</td>
                                                                <td>
                                                                    <input
                                                                        value={billBatch?.qtyConsumed}
                                                                        type="text"
                                                                        name="qtyConsumed"
                                                                        onChange={(e) => handleSubRowchanges(i, j, e.target.value, "qtyConsumed", billBatch?.batchQuantity, billBatch.batchNumber)}
                                                                        isDisabled={itemLoading}
                                                                        disabled={!billBatch?.batchNumber || itemLoading}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        value={billBatch?.batchManufacturingDate}
                                                                        type="date"
                                                                        name="batchManufacturingDate"
                                                                        onChange={(e) => handleSubRowchanges(i, j, e.target.value, "batchManufacturingDate")}
                                                                        disabled={true}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        value={billBatch?.batchExpiredDate}
                                                                        type="date"
                                                                        name="batchExpiredDate"
                                                                        onChange={(e) => handleSubRowchanges(i, j, e.target.value, "batchExpiredDate")}
                                                                        disabled={true}
                                                                    />
                                                                </td>
                                                                <td style={{ width: "30px" }}>
                                                                    <button
                                                                        className="btn btn-default addbtn"
                                                                        onClick={() => removeSubRows(i, j)}
                                                                    >
                                                                        X
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    }
                                                    )}
                                                </table>
                                            </td>
                                        </tr> */}
                                    </Fragment>
                                );
                            })}
                    </tbody>
                </table>

                {selectedWarehouse && (
                    <>
                        <div>
                            <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handleAddRow}>
                                <AddIcon style={{ color: "blue" }} /> New Row
                            </button>
                        </div>
                        <br />
                        <div>
                            {loading ? (
                                <Button variant="contained">
                                    <Spinner />
                                </Button>
                            ) : (
                                <Button variant="contained" onClick={handleSave}>
                                    Save
                                </Button>
                            )}
                        </div>
                    </>
                )}
            </div>
            <Toaster />
        </>
    );
};

export default StockClosingNew;
